import UploadFilesApis from '../../apis/fileUpload';

const DIR_NAME = process.env.DIR_NAME;
const BUCKET_NAME = process.env.BUCKET_NAME;
const BUCKET_ORIGIN = process.env.BUCKET_ORIGIN;

export const uploadToS3 = (file) =>
  new Promise((resolve, reject) => {
    const upload = async () => {
      const fileName = file.name;
      const s3PreSignedURLPayload = { file_type: file.type, file_path: `${DIR_NAME}/${Date.now().toString()}-${fileName}`, bucket: BUCKET_NAME };
      const s3PreSignedURLResponse = await UploadFilesApis.getS3PresignedURL(s3PreSignedURLPayload);

      if (s3PreSignedURLResponse.ok) {
        const s3PreSignedURLJSON = await s3PreSignedURLResponse.json();

        await fetch(s3PreSignedURLJSON.data, { method: 'PUT', body: file, headers: { ContentType: file.type } });
        const updateACLPayload = { acl: 'public-read', file_path: s3PreSignedURLPayload.file_path, bucket: BUCKET_NAME };
        const updateACLResponse = await UploadFilesApis.updateACL(updateACLPayload);

        if (updateACLResponse.ok) {
          resolve({
            message: 'file uploaded',
            url: `${BUCKET_ORIGIN}/${s3PreSignedURLPayload.file_path}`
          });
        } else {
          reject(new Error('failed to upload'));
        }
      }

      reject(new Error('failed to upload'));
    };

    upload();
  });
